import React from 'react';

import MyTISection from './Section';

const MyTIDataTools = () => {
  return (
    <MyTISection
      highlight="Label"
      subtitle="Lorem ipsum dolor sit amet consectetur adipisicing elit"
      title="Data Tools"
    >
      <div>Data Tools</div>
    </MyTISection>
  );
};

export default MyTIDataTools;
